import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Header from './components/Header';
import Homepage from './pages/Homepage';
import ProspectsTerminalPage from './pages/ProspectsTerminalPage';
import ProspectPage from './pages/ProspectPage/ProspectPage';
import Boards from './pages/Boards';
import LanguageContextProvider from './context/LanguageContext';
import UpdateContextProvider from './context/UpdateContext';

function App() {
  return (

    <Router>
      <UpdateContextProvider>
      <LanguageContextProvider>
        <div className="App h-dvh min-w-screen">
          <Header />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/boards" element={<Boards />} />
            <Route path="/prospects" element={<ProspectsTerminalPage />} />
            <Route path="/prospects/:id/:full_name" element={<ProspectPage />} />
          </Routes>
        </div>
      </LanguageContextProvider>
      </UpdateContextProvider>
    </Router>

  );
}

export default App;